import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { useResponsiveDialog } from "../../../../../Context/ResponsiveDialogContext";
import { getValidationRules, isFieldRequired } from "../PreLoan";

export default function StepTenant() {
    const { control, formState: { errors } } = useFormContext();
    const { containerWidth } = useResponsiveDialog();

    const isSmall = containerWidth > 0 && containerWidth < 500;
    const stepKey = 'tenant'; // Definir el stepKey para este componente

    return (
        <div className="p-fluid">
            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-8'}`}>
                    <label>Nombre del arrendatario{isFieldRequired('tenant.nombreArrendatario', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.nombreArrendatario" control={control} rules={getValidationRules('tenant.nombreArrendatario', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.nombreArrendatario && <small className="p-error">{errors.tenant.nombreArrendatario.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>No. Contrato{isFieldRequired('tenant.numeroContrato', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.numeroContrato" control={control} rules={getValidationRules('tenant.numeroContrato', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.numeroContrato && <small className="p-error">{errors.tenant.numeroContrato.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label>Domicilio Particular{isFieldRequired('tenant.domicilioParticular', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.domicilioParticular" control={control} rules={getValidationRules('tenant.domicilioParticular', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.domicilioParticular && <small className="p-error">{errors.tenant.domicilioParticular.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label>Domicilio Fiscal{isFieldRequired('tenant.domicilioFiscal', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.domicilioFiscal" control={control} rules={getValidationRules('tenant.domicilioFiscal', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.domicilioFiscal && <small className="p-error">{errors.tenant.domicilioFiscal.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>RFC{isFieldRequired('tenant.rfc', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.rfc" control={control} rules={getValidationRules('tenant.rfc', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.rfc && <small className="p-error">{errors.tenant.rfc.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Núm. Teléfono{isFieldRequired('tenant.telefono', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.telefono" control={control} rules={getValidationRules('tenant.telefono', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.telefono && <small className="p-error">{errors.tenant.telefono.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Correo{isFieldRequired('tenant.correo', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.correo" control={control} rules={getValidationRules('tenant.correo', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.correo && <small className="p-error">{errors.tenant.correo.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Act. Económica{isFieldRequired('tenant.actividadEconomica', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.actividadEconomica" control={control} rules={getValidationRules('tenant.actividadEconomica', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.actividadEconomica && <small className="p-error">{errors.tenant.actividadEconomica.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Entidad Fed.{isFieldRequired('tenant.entidadFederativa', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.entidadFederativa" control={control} rules={getValidationRules('tenant.entidadFederativa', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.entidadFederativa && <small className="p-error">{errors.tenant.entidadFederativa.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>CURP{isFieldRequired('tenant.curp', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.curp" control={control} rules={getValidationRules('tenant.curp', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.curp && <small className="p-error">{errors.tenant.curp.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Opinión Cumplimiento{isFieldRequired('tenant.opinionCumplimiento', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.opinionCumplimiento" control={control} rules={getValidationRules('tenant.opinionCumplimiento', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.opinionCumplimiento && <small className="p-error">{errors.tenant.opinionCumplimiento.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Estatus{isFieldRequired('tenant.estatus', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.estatus" control={control} rules={getValidationRules('tenant.estatus', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.estatus && <small className="p-error">{errors.tenant.estatus.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>IdCIF{isFieldRequired('tenant.idCIF', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.idCIF" control={control} rules={getValidationRules('tenant.idCIF', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.idCIF && <small className="p-error">{errors.tenant.idCIF.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label>Régimen Fiscal{isFieldRequired('tenant.regimenFiscal', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.regimenFiscal" control={control} rules={getValidationRules('tenant.regimenFiscal', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.regimenFiscal && <small className="p-error">{errors.tenant.regimenFiscal.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label>F. de nacimiento{isFieldRequired('tenant.fechaNacimiento', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.fechaNacimiento" control={control} rules={getValidationRules('tenant.fechaNacimiento', stepKey)} render={({ field }) => (
                        <Calendar
                            id={field.name}
                            name={field.name}
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            className="w-full"
                            dateFormat="yy-mm-dd"
                            showIcon
                        />
                    )} />
                    {errors.tenant?.fechaNacimiento && <small className="p-error">{errors.tenant.fechaNacimiento.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Identificación{isFieldRequired('tenant.identificacion', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.identificacion" control={control} rules={getValidationRules('tenant.identificacion', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.identificacion && <small className="p-error">{errors.tenant.identificacion.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Clave de Elector{isFieldRequired('tenant.claveElector', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.claveElector" control={control} rules={getValidationRules('tenant.claveElector', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.claveElector && <small className="p-error">{errors.tenant.claveElector.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>NSS{isFieldRequired('tenant.nss', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.nss" control={control} rules={getValidationRules('tenant.nss', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.tenant?.nss && <small className="p-error">{errors.tenant.nss.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label>Emisión Identificación{isFieldRequired('tenant.emisionIdentificacion', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.emisionIdentificacion" defaultValue={new Date()} rules={getValidationRules('tenant.emisionIdentificacion', stepKey)} control={control} render={({ field }) => (
                        <Calendar
                            id={field.name}
                            name={field.name}
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            className="w-full"
                            dateFormat="yy-mm-dd"
                            showIcon
                        />
                    )} />
                    {errors.tenant?.emisionIdentificacion && <small className="p-error">{errors.tenant.emisionIdentificacion.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label>Vigencia Identificación{isFieldRequired('tenant.vigenciaIdentificacion', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.vigenciaIdentificacion" control={control} rules={getValidationRules('tenant.vigenciaIdentificacion', stepKey)} render={({ field }) => (
                        <Calendar
                            id={field.name}
                            name={field.name}
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            className="w-full"
                            dateFormat="yy-mm-dd"
                            showIcon
                        />
                    )} />
                    {errors.tenant?.vigenciaIdentificacion && <small className="p-error">{errors.tenant.vigenciaIdentificacion.message}</small>}
                </div>
            </div>
        </div>
    );
}
